export default {
  name: "Payment Request",
  meta: {
    icon: "directions_boat",
    expanded: true,
    auth: true,
  },
  departmentName: "Accounts",
  finalPagePermision: "Sea_Export_SLine_Payment",
  children: [
    {
      name: "S/Line Approval List ",
      path: "/freightForward/slineApprovalList",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: ["S/Line Approval List "],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/payment/SlineApprovalList.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },
    {
      name: "S/Line Payment Desk ",
      path: "/freightForward/slinePay",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: [
        "S/Line Payment Details ",
        "Sea_Export_SLine_Payment",
        "S/Line Bulk Payment,S/Line Payment Planing",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/freightForwarding/slinePaymentDetails.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },
    // {
    //     name: "Live Payment",
    //     path: "/freightForward/live-payment",
    //     permissionName: 'Sea_Export_SLine_Payment',
    //     keywords: ['S/Line Payment Details ', 'Sea_Export_SLine_Payment,S/Line Bulk Payment,S/Line Payment Planing'],
    //     meta: {
    //         icon: "directions_boat",
    //         auth: true,
    //     },
    //     component: require("../component/payment/slinePaymentSortFinalList.vue"),
    //     finalPagePermision: "Sea_Export_SLine_Payment",
    // },
    {
      name: "S/Line Payment Planning",
      path: "/freightForward/sline-payment-plan",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: [
        "S/Line Payment Details ",
        "Sea_Export_SLine_Payment,S/Line Bulk Payment,S/Line Payment Planing",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/payment/Tab.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },
    {
      name: "S/Line Bulk Payment",
      path: "/freightForward/bulk-sline-payment",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: [
        "S/Line Payment Details ",
        "Sea_Export_SLine_Payment,S/Line Bulk Payment,S/Line Payment Planning",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/payment/slineBulkPayment.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },
    {
      name: "SLine Bulk Payment Log List",
      path: "/freightForward/bulk-log-sline-payment",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: [
        "S/Line Payment Details ",
        "Sea_Export_SLine_Payment,S/Line Bulk Payment",
        "SLine Bulk Payment Log List,S/Line Payment Planing",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/payment/slineBulkPaymentLog.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },
    {
      name: "Expense Payment Details ",
      path: "/Expense/expPaymentDash",
      permissionName: "Sea_Export_SLine_Payment",
      keywords: [
        "Expense Payment Details ",
        "Sea_Export_SLine_Payment",
        "S/Line Bulk Payment,S/Line Payment Planing",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/allModuleForm/ExpensePaymentDashboard.vue"),
      finalPagePermision: "Sea_Export_SLine_Payment",
    },

    // {
    //   name: "Assignment Details ",
    //   path: "/freightForward/slinePay",
    //   meta: {
    //     auth: true,
    //   },
    //   component: require("../component/freightForwarding/slinePaymentDetails.vue"),
    //   // component: require("../component/freightForwarding/slinePaymentDetailsNew.vue"),
    //   finalPagePermision: "Sea_Export_SLine_Payment",
    // },
    // {
    //   name: "Test Assignment Details ",
    //   path: "/freightForward/slinePayNew",
    //   meta: {
    //     auth: true,
    //   },
    //   // component: require("../component/freightForwarding/slinePaymentDetails.vue"),
    //   component: require("../component/freightForwarding/slinePaymentDetailsNew.vue"),
    //   finalPagePermision: "Sea_Export_SLine_Payment",

    // },

    // {
    //   name: "Freight Container Details ",
    //   path: "/freightForward/mergeFreightContainers",
    //   meta: {
    //     auth: true
    //   },
    //   component: require("../component/freightForwarding/mergeFreightContainers.vue"),
    //   finalPagePermision: "Sea Export",
    // },

    // {
    //   name: " Normal Sea Export Booking Details ",
    //   path: "/freightForward/viewFCLBooking",
    //   meta: {
    //     auth: true
    //   },
    //   component: require("../component/freightForwarding/viewFCLBooking.vue"),
    //   finalPagePermision: "Sea Export",
    // },

    // {
    //   name: "Consolidation Details ",
    //   path: "/ffExportCon/viewFFConsoExport",
    //   meta: {
    //     auth: true
    //   },
    //   component: require("../component/ffExportCon/viewFFConsoExport.vue"),
    //   finalPagePermision: "Sea Export",
    // },
    // {
    //   name: "Conso-Sea Export Booking Details ",
    //   path: "/ffExportCon/viewConsoBooking",
    //   meta: {
    //     auth: true
    //   },
    //   component: require("../component/ffExportCon/viewFclConsoBookingDetail.vue"),
    //   finalPagePermision: "Sea Export",
    // },
    // {
    //   name: "Conso-Sea Export Execution Details ",
    //   path: "/ffExportCon/viewConExecDetail",
    //   meta: {
    //     auth: true
    //   },
    //   component: require("../component/ffExportCon/viewConExecDetail.vue"),
    //   finalPagePermision: "Sea Export",
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/sidebar/ffSeaExSlinePay.js